export const UPDATE_LATORI_PROGRAM = "UPDATE_LATORI_PROGRAM";
export const UPDATE_MANY_LATORI_PROGRAMS = "UPDATE_MANY_LATORI_PROGRAMS";
export const LOAD_LATORI_PROGRAM = "LOAD_LATORI_PROGRAM";
export const LOAD_LATORI_PROGRAMS = "LOAD_LATORI_PROGRAMS";
export const DELETE_LATORI_PROGRAM = "DELETE_LATORI_PROGRAM";
export const DELETE_MANY_LATORI_PROGRAMS = "DELETE_MANY_LATORI_PROGRAMS";
export const CLEAR_LATORI_PROGRAMS = "CLEAR_LATORI_PROGRAMS";
